import React, { useState } from "react";
import Constants from "../../data/Constants";
import { IoClose } from "react-icons/io5";
import NavItem from "./NavItem";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";

function Navigation(props) {
  const { setNav, nav, onSelect, menu, active, setActive, className } = props;
  const navigate = useNavigate();

  const closeHandler = () => {
    setNav(!nav);
  };

  const clickHandler = (e) => {
    e.preventDefault();
    setActive(e.currentTarget.getAttribute("index"));
    onSelect(menu[e.currentTarget.getAttribute("index")]);
    if (isMobile) {
      closeHandler();
    }
  };

  return (
    <div
      className={
        `z-50 fixed left-0 sm:relative transition-transform shadow-lg sm:shadow-none h-screen overflow-scroll bg-primary scroll-smooth ` +
        (nav ? "translate-x-0" : "-translate-x-full") +
        " " +
        className
      }
    >
      <div className={`p-3 float-right ` + (!isMobile ? "invisible" : "")}>
        <IoClose
          className="cursor-pointer text-white "
          size={24}
          onClick={closeHandler}
        />
      </div>
      <div className="w-full my-5">
        <img
          src={process.env.PUBLIC_URL + Constants.APP_LOGO.WHITE}
          className="w-auto sm:h-12 h-8 object-cover mx-auto"
        />
      </div>
      <div className="px-8 my-5 ">
        {menu.map((item, index) => {
          return (
            <NavItem
              name={item.name}
              onClick={clickHandler}
              icon={item.icon}
              active={index == active}
              key={index}
              index={index}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Navigation;
